import { escapeHtml } from "./dom.js";

function pct(value) {
  const n = Number(value);
  return Number.isFinite(n) ? `${(n * 100).toFixed(1)}%` : "—";
}

function count(value) {
  const n = Number(value);
  return Number.isFinite(n) ? String(Math.max(0, Math.trunc(n))) : "0";
}

function rowsHtml(rows) {
  return rows
    .map(
      ([label, value]) =>
        `<div class="ops-fcm-mig-row"><dt>${escapeHtml(label)}</dt><dd class="mono">${escapeHtml(String(value))}</dd></div>`,
    )
    .join("");
}

function distributionRows(raw, emptyLabel) {
  const entries = raw && typeof raw === "object" ? Object.entries(raw) : [];
  if (!entries.length) return [[emptyLabel, "0"]];
  return entries.slice(0, 8).map(([label, value]) => [String(label), count(value)]);
}

export function aiIncidentObservabilityHtml(ai, scope = "sa") {
  const data = ai && typeof ai === "object" ? ai : {};
  if (data.source === "unavailable" || data.last_error) {
    return `<p class="muted">AI decision metrics are temporarily unavailable.</p>`;
  }

  const runtime = data.runtime && typeof data.runtime === "object" ? data.runtime : {};
  const enrich = data.enrich_status && typeof data.enrich_status === "object"
    ? data.enrich_status
    : {};
  const summary = [
    ["Decisions", count(data.incidents_total)],
    ["Auto call", `${count(data.auto_call_total)} · ${pct(data.auto_call_rate)}`],
    ["Waiting approval", count(data.pending_total)],
    ["Dispatch linked", count(data.dispatch_linked_total)],
    ["Tier-2 timeout", count(data.escalation_total)],
  ];
  const quality = [
    ["Model live", count(enrich.live)],
    ["Fallback", `${count(enrich.fallback)} · ${pct(data.enrich_fallback_rate)}`],
    ["Rules only", count(enrich.rules)],
    ["Unknown mode", count(enrich.unknown)],
    ["Runtime timeout", pct(runtime.enrich_timeout_rate)],
    ["Runtime latency", runtime.enrich_latency_ms_avg != null
      ? `${count(runtime.enrich_latency_ms_avg)} ms`
      : "—"],
  ];
  const cols = [
    `<div class="ops-fcm-mig-col"><p class="muted ops-fcm-mig-col-title">Last ${count(data.window_hours || 24)}h</p><dl class="ops-fcm-mig-dl">${rowsHtml(summary)}</dl></div>`,
    `<div class="ops-fcm-mig-col"><p class="muted ops-fcm-mig-col-title">Enrichment</p><dl class="ops-fcm-mig-dl">${rowsHtml(quality)}</dl></div>`,
  ];

  if (scope !== "admin") {
    cols.push(
      `<div class="ops-fcm-mig-col"><p class="muted ops-fcm-mig-col-title">Models used</p><dl class="ops-fcm-mig-dl">${rowsHtml(distributionRows(data.model_used_distribution, "No model samples"))}</dl></div>`,
      `<div class="ops-fcm-mig-col"><p class="muted ops-fcm-mig-col-title">Dispatch skips</p><dl class="ops-fcm-mig-dl">${rowsHtml(distributionRows(data.dispatch_skip_reasons, "No skips"))}</dl></div>`,
    );
  }

  return `<div class="ops-fcm-mig-cols">${cols.join("")}</div>
    <p class="muted" style="margin:8px 0 0;font-size:11px">Durable counts: PostgreSQL · runtime timeout/latency: this API process only.</p>`;
}
